// Path: src/components/auth/OLS.tsx

import React, { useState, useEffect, useCallback } from "react";
import ImgOlslm from "./components/ImgOlslm/ImgOlslm";
import { loginImgURLs } from "./constants/LoginImg";
import styled from "styled-components";
import "./login.css"; // Import login.css for styling

// Styled container for the OLS main gate page
const OLSContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const OLS: React.FC = () => {
  // State for managing image URL in ImgOlslm component
  const [imageUrl, setImageUrl] = useState<string>("OLSLM");

  // State for controlling image open/close in ImgOlslm
  const [isImageOpen, setIsImageOpen] = useState<boolean>(false);

  // State for controlling estate open/close in ImgOlslm
  const [isEstateOpen, setIsEstateOpen] = useState<boolean>(false);

  // State for question list in ImgOlslm
  const [questionList, setQuestionList] = useState<string[]>([]);

  // State for active question in ImgOlslm
  const [activeQW, setActiveQW] = useState<string>("");

  // State for title URL in ImgOlslm
  const [titleUrl, setTitleUrl] = useState<string>("");

  // State for window dimensions
  const [dimensions, setDimensions] = useState<{ width: number; height: number }>({ width: 0, height: 0 });

  // Update window dimensions on resize
  const updateWindowDimensions = useCallback(() => {
    setDimensions({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  }, []);

  // Set up window dimensions and resize listener
  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);
    return () => window.removeEventListener("resize", updateWindowDimensions);
  }, [updateWindowDimensions]);

  // Handle image change in ImgOlslm
  const onChange = useCallback(
    (value: string) => {
      setImageUrl(value === "982.9.11.3400" ? loginImgURLs[20] : value);
      setTitleUrl(value === "982.9.11.3400" ? "982.9.11.3400" : "");
    },
    []
  );

  // Toggle estate visibility in ImgOlslm
  const toggleEstate = useCallback(() => setIsEstateOpen((prev) => !prev), []);

  // Toggle image visibility in ImgOlslm
  const onImageClick = useCallback(() => setIsImageOpen((prev) => !prev), []);

  // Handle arrow clicks for image navigation in ImgOlslm
  const onArrowClick = useCallback(
    (direction: "up" | "down") => setImageUrl(direction === "up" ? loginImgURLs[0] : loginImgURLs[1]),
    []
  );

  // Handle question selection in ImgOlslm
  const onQuestionHandler = useCallback((qw: string) => {
    setQuestionList(["0-10", "11-20", "21-30", "31-40", "41-50", "51-60", "61-70", "71-80", "81-90"]);
    setActiveQW(qw);
  }, []);

  // Handle image URL change in ImgOlslm
  const onChangeImageUrlHandler = useCallback((imageUrl: string) => setImageUrl(imageUrl), []);

  return (
    <OLSContainer>
      {/* Image component wrapper */}
      <div className="img-olslm-wrapper">
        <ImgOlslm
          state={{ imageUrl, isImageOpen, isEstateOpen, images: loginImgURLs, questionList, activeQW, titleUrl, ...dimensions }}
          titleUrl={titleUrl}
          onArrowClick={onArrowClick}
          onChange={onChange}
          onChangeImageUrlHandler={onChangeImageUrlHandler}
          onImageClick={onImageClick}
          onQuestionHandler={onQuestionHandler}
          onChildQuestionHandler={onQuestionHandler}
        />
      </div>
    </OLSContainer>
  );
};

export default OLS;